import { render, staticRenderFns } from "./switchCard.vue?vue&type=template&id=23dd1bde&scoped=true&"
import script from "./switchCard.vue?vue&type=script&lang=js&"
export * from "./switchCard.vue?vue&type=script&lang=js&"
import style0 from "./switchCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./switchCard.vue?vue&type=style&index=1&id=23dd1bde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd1bde",
  null
  
)

export default component.exports